const currency = (field) => {
  return `<span style="float: left" class="#=${field} < 0 ? 't-danger' : 't-normal' #">$</span><span style="float: right" class="#=${field} < 0 ? 't-danger' : 't-normal' #">#=kendo.toString(${field}, 'n2')#</span>`;
};

const currencyDifference = (differenceField) => {
  return `<span style="float: left" class="#=${differenceField} < 0 ? 't-danger' : 't-normal' #">$</span><span style="float: right" class="#=${differenceField} < 0 ? 't-danger' : 't-normal' #">#=kendo.toString(${differenceField} - rowSum(), 'n2')#</span>`;
};

const number = (field) => {
  return `<span style="float: right" class="#=${field} < 0 ? 't-danger' : 't-normal' #">#=kendo.toString(${field}, 'n2')#</span>`;
};

const numberDifference = (differenceField) => {
  return `<span style="float: right" class="#=${differenceField} < 0 ? 't-danger' : 't-normal' #">#=kendo.toString(${differenceField} - rowSum(), 'n2')#</span>`;
};

/*
 * Clipped variants of the currency and number templates.
 *
 * The plain templates float the currency symbol left and the value right. Those are two
 * floats in a fixed-width column, so a value too wide to sit beside the symbol drops onto a
 * second line: that is the wrap that shows up in the narrow columns. Flex keeps them on one
 * row and lets the value clip to an ellipsis instead. See .cell-clip in
 * less/kendo/overrides/grid/grid.less, which carries the min-width:0 that lets a flex item
 * shrink far enough for text-overflow to apply at all.
 *
 * The untruncated value goes in a title attribute rather than a kendoTooltip: the grid
 * rebuilds its cells on every rebind, so a widget bound to those elements would have to be
 * rebuilt with them, whereas the attribute is simply part of the cell.
 *
 * That title sits on the value span rather than the wrapper. A native title is inherited by
 * any descendant without one of its own, so on the wrapper it would also cover the prefix
 * slot: hovering the projected-hours warning icon, which carries its own kendoTooltip from
 * addWarnings, would raise both tooltips at once. The value is also the part that clips, and
 * so the part worth expanding.
 */
const clippedCell = (field, { prefix = '', titlePrefix = '' } = {}) => {
  const value = `kendo.toString(${field}, 'n2')`;
  const tone = `#=${field} < 0 ? 't-danger' : 't-normal' #`;
  const lead = prefix ? `<span class="cell-clip__prefix ${tone}">${prefix}</span>` : '';
  return `<span class="cell-clip">`
    + lead
    + `<span class="cell-clip__value ${tone}" title="${titlePrefix}#=${value}#">#=${value}#</span>`
    + `</span>`;
};

const currencyClipped = (field) => clippedCell(field, { prefix: '$', titlePrefix: '$' });

// The prefix is markup, so a caller can put something conditional in the fixed slot beside
// the value; the projected-hours warning icon does exactly that. It is deliberately kept out
// of the title, which shows the value on its own.
const numberClipped = (field, prefix = '') => clippedCell(field, { prefix });

const percentage = function(field) {
  return `<span style="float: right" class="#=${field} < 0 ? 't-danger' : 't-normal' #">#=kendo.toString(${field} * 100, 'n2')# %</span>`;
};

const string = (field) => {
  return `<span>#=${field}#</span>`;
};

const hours = (field) => {
  return `<span style="float: right">#=kendo.toString(${field}, 'n0')# h</span>`;
};

const fte = (field) => {
  return `<span style="float: right">#=kendo.toString(${field}, 'n2')# FTE</span>`;
};

const columnBasedTemplate = function(dataItem) {
  const me = this;
  const template = kendo.template(getTemplate(dataItem[me.columnTypeField])(me.field));
  return template(dataItem);
};

const columnBased = function(field, columnTypeField = this) {
  const templateInfo = {columnTypeField, field};
  return columnBasedTemplate.bind(templateInfo);
};

const currencyEditor = (container, options) => {
  const {field, model} = options;
    $(`<input name="${options.field}" style="text-align: right" autocomplete="off"/>`)
    .appendTo(container)
    .kendoNumericTextBox({
      decimals: 2,
      selectOnFocus: true,
        value: model[field] ?? '',

    });
};

const numberEditor = (container, options) => {
  const {field, model} = options;
    $(`<input name="${options.field}" style="text-align: right" autocomplete="off"/>`)
  .appendTo(container)
  .kendoNumericTextBox({
    decimals: 2,
    step: .5,
    selectOnFocus: true,
    value: model[field] ?? ''
  });
};

const percentageEditor = (container, options) => {
  const {field, model} = options;
    $(`<input name="${options.field}" style="text-align: right" autocomplete="off"/>`)
  .appendTo(container)
  .kendoNumericTextBox({
    decimals: 2,
    step: .5,
    selectOnFocus: true,
    value: model[field] ?? ''
  });
};

const templates = {
  currency,
  currencyClipped,
  currencyDifference,
  currencyEditor,
  hours,
  fte,
  number,
  numberClipped,
  numberDifference,
  numberEditor,
  percentage,
  percentageEditor,
  columnBased,
  string
};

export const getTemplate = (type, columnName = undefined) => {
  switch(type){
    case 'number': return templates.number;
    case 'currency': return templates.currency;
    case 'hours': return templates.hours;
    case 'fte': return templates.fte;
    case 'percent':
    case 'percentage': return templates.percentage;
    case 'columnBased': return templates.columnBased.bind(columnName);
    default: return templates.string;
  }
};

export const getEditor = (type) => {
  switch(type){
    case 'number': return templates.numberEditor;
    case 'currency': return templates.currencyEditor;
      case 'percent':
    case 'percentage': return templates.percentageEditor;
    default: return undefined;
  }
};

export default templates;
